export default "__VITE_ASSET__8YV_ZBOp__"